<span class="powered" [ngClass]="{small}">Powered by</span>
<span class="epson" [ngClass]="{small}">EPSON</span>
